import type { KnowledgeArticleTranslations } from './articles.types';

export const KNOWLEDGE_BASE_ARTICLES_UR: KnowledgeArticleTranslations = {
  pickup: {
    title: 'وصولی کے آرڈرز',
    summary: "پک اپ آرڈر بنائیں، ٹریک کریں اور منظم کریں۔",
    content:
      'وصولی کے آرڈرز آپ کی سائٹس سے کچرے کی وصولی کا شیڈول بنانے کے لیے استعمال ہوتے ہیں۔ سائیڈ بار سے «وصولی کے آرڈرز» کھولیں تاکہ نیا آرڈر بنائیں، فہرست دیکھیں یا ان کی صورتحال ٹریک کریں۔\n\nمرحلہ وار ہدایات کے لیے نیچے ایک گائیڈ منتخب کریں۔',
  },
  'view-pickup-orders-list': {
    title: "پک اپ آرڈرز کی فہرست دیکھیں",
    summary: "آرڈرز ٹیبل کھولیں، تلاش کریں اور پک اپ درخواستیں دیکھیں۔",
    content:
      "1. سائیڈ بار میں «پک اپ آرڈرز» کھولیں۔\n\n2. مرکزی ٹیبل میں آپ کی تنظیم کے پک اپ آرڈر ID، جمع کرنے کا مقام، حیثیت اور تاریخوں کے ساتھ دکھاتے ہیں۔\n\n3. ID یا جمع مقام سے آرڈر تلاش کے لیے ٹیبل کے اوپر سرچ باکس استعمال کریں۔\n\n4. مزید قطاریں دیکھنے کے لیے سکرول کریں اور نیچے پیجینیشن استعمال کریں۔\n\nٹپ: حیثیت چپس اور تاریخ فلٹرز نتائج محدود کرتے ہیں — متعلقہ گائیڈز دیکھیں۔",
  },
  'create-pickup-order-outlet': {
    title: 'نیا وصولی آرڈر بنائیں',
    summary: "فضلے کی پک اپ شیڈول کرنے کی مرحلہ وار گائیڈ۔",
    content:
      '1. سائیڈ بار سے «وصولی کے آرڈرز» کھولیں پھر «وصولی آرڈر بنائیں» (یا وصولی آرڈرز کے صفحے پر + بٹن دبائیں)۔\n\n2. آرڈر کی تفصیلات:\n   • مواد کی قسم (لازمی) — کچرے کی قسم اور ناپ کی اکائی خود بخود بھر جاتی ہے۔\n\n3. مقام اور کنٹینر:\n   • جمع کرنے کی سائٹ (لازمی)\n   • منتخب سائٹ پر موجود کنٹینر\n   • بھرائی کی سطح — مکمل بھرا ہوا، تین چوتھائی، آدھا بھرا ہوا، یا ایک چوتھائی بھرا ہوا\n\n4. «محفوظ کریں» پر کلک کریں۔ آرڈر فہرست میں «زیر التواء» کی صورتحال کے ساتھ ظاہر ہوگا۔',
  },
  material: {
    title: 'مواد',
    summary: "پک اپ آرڈرز کے لیے مواد کی اقسام شامل، ترمیم اور منظم کریں۔",
    content:
      'مواد کی اقسام شامل کرنے اور ان میں ترمیم کرنے کا طریقہ جاننے کے لیے نیچے سے ایک گائیڈ منتخب کریں۔',
  },
  'add-material-type': {
    title: 'مواد کی قسم شامل کریں',
    summary: "پک اپ آرڈرز کے لیے فضلہ مواد کی قسم رجسٹر کریں۔",
    content:
      '1. سائیڈ بار سے «دوبارہ تدویر» کھولیں پھر «مواد کی اقسام»۔\n\n2. «مواد شامل کریں» (اوپر دائیں) پر کلک کریں۔\n\n3. مواد کا نام، زمرہ اور ناپ کی اکائی درج کریں (مثلاً: کلو، ٹن، تھیلے)۔\n\n4. «محفوظ کریں» پر کلک کریں۔ مواد وصولی آرڈرز بناتے وقت دستیاب ہو جائے گا۔',
  },
  container: {
    title: 'کنٹینرز',
    summary: "فضلے کے کنٹینر شامل، منظم اور ٹریک کریں۔",
    content:
      'کنٹینرز کا انتظام کرنے کا طریقہ جاننے کے لیے نیچے سے ایک گائیڈ منتخب کریں۔',
  },
  'add-container': {
    title: 'نیا کنٹینر شامل کریں',
    summary: "جمع کرنے کے مقام پر فضلہ کنٹینر رجسٹر کریں۔",
    content:
      '1. سائیڈ بار سے «کنٹینرز» کھولیں پھر «کنٹینرز کی فہرست»۔\n\n2. «کنٹینر شامل کریں» (اوپر دائیں) پر کلک کریں۔\n\n3. کنٹینر کی تفصیلات بھریں: نام، مواد کی قسم، جمع کرنے کی سائٹ، صورتحال، اور دیگر لازمی خانے۔\n\n4. «محفوظ کریں» پر کلک کریں۔ کنٹینر فہرست میں ظاہر ہوگا اور وصولی آرڈرز بناتے وقت منتخب کیا جا سکے گا۔',
  },
  'collection-site': {
    title: 'جمع کرنے کی سائٹیں',
    summary: "فضلے کے جمع مقامات شامل، ترمیم اور منظم کریں۔",
    content:
      'جمع کرنے کی سائٹوں کا انتظام کرنے کا طریقہ جاننے کے لیے نیچے سے ایک گائیڈ منتخب کریں۔',
  },
  'add-collection-site': {
    title: 'نئی جمع کرنے کی سائٹ شامل کریں',
    summary: "ایسا مقام بنائیں جہاں فضلہ جمع ہوتا ہے۔",
    content:
      '1. سائیڈ بار سے «کنٹینرز» کھولیں پھر «جمع کرنے کی سائٹیں»۔\n\n2. «سائٹ شامل کریں» (اوپر دائیں) پر کلک کریں۔\n\n3. سائٹ کا نام، پتہ اور دیگر ضروری تفصیلات درج کریں۔\n\n4. «محفوظ کریں» پر کلک کریں۔ اب آپ کنٹینرز کو اس سائٹ سے منسلک کر سکتے ہیں اور وصولی آرڈر فارموں میں اسے منتخب کر سکتے ہیں۔',
  },

  truck: {
    title: 'ٹرکس',
    summary: "گاڑیاں شامل کریں، فلیٹ کی حالتیں سمجھیں اور ٹرک منظم کریں۔",
    content:
      'گاڑیوں کے بیڑے کا انتظام کرنے کا طریقہ جاننے کے لیے نیچے سے ایک گائیڈ منتخب کریں۔',
  },
  'add-vehicle': {
    title: 'گاڑی شامل کریں',
    summary: "مکمل تفصیلات کے ساتھ نیا ٹرک یا فلیٹ گاڑی رجسٹر کریں۔",
    content:
      '1. سائیڈ بار سے «ٹرکس» کھولیں تاکہ «بیڑے کا انتظام» تک رسائی حاصل ہو۔\n\n2. «گاڑی شامل کریں» (اوپر دائیں) پر کلک کریں۔\n\n3. فارم بھریں:\n   • نمبر پلیٹ (عربی اور انگریزی)\n   • گاڑی کا نام (لازمی)\n   • گنجائش اور گنجائش کی اکائی\n   • گاڑی کی قسم، ماڈل، VIN، خالی وزن اور ایندھن کی کھپت\n   • صورتحال — اگر گاڑی تفویض کے لیے تیار ہے تو «دستیاب» منتخب کریں\n\n4. «محفوظ کریں» پر کلک کریں۔ گاڑی بیڑے کی جدول میں ظاہر ہوگی۔',
  },
  driver: {
    title: 'ڈرائیورز',
    summary: "ڈرائیور رجسٹر کریں، پروفائل دیکھیں اور ٹرک تفویض منظم کریں۔",
    content:
      'ڈرائیورز کا انتظام کرنے کا طریقہ جاننے کے لیے نیچے سے ایک گائیڈ منتخب کریں۔',
  },
  'add-driver': {
    title: 'ڈرائیور شامل کریں',
    summary: "لائسنس اور ذاتی تفصیلات کے ساتھ ڈرائیور اکاؤنٹ بنائیں۔",
    content:
      '1. سائیڈ بار سے «ڈرائیورز» کھولیں۔\n\n2. «ڈرائیور شامل کریں» (اوپر دائیں) پر کلک کریں۔\n\n3. اکاؤنٹ کا حصہ: ای میل، پاس ورڈ اور اس کی تصدیق۔\n\n4. ذاتی معلومات کا حصہ: نام، فون نمبر، جنس، قومیت، اور دیگر۔\n\n5. ڈرائیور اور گاڑی کا حصہ: ڈرائیونگ لائسنس نمبر، میعاد ختم ہونے کی تاریخ، اور گاڑی کی رجسٹریشن نمبر۔\n\n6. «محفوظ کریں» پر کلک کریں۔ ڈرائیور جدول میں ظاہر ہوگا۔',
  },
  'understanding-notifications': {
    title: 'اطلاعات',
    summary: "پلیٹ فارم الرٹس کو فعال کرنے، پڑھنے اور منظم کرنے کا طریقہ۔",
    content:
      'براؤزر کی اطلاعات فعال کریں:\nجب اجازت کی درخواست آئے تو «اجازت دیں» پر کلک کریں تاکہ ایپ کے باہر آرڈرز اور پلیٹ فارم کی تازہ کاریوں کی اطلاعات مل سکیں۔\n\nاطلاعات دیکھیں:\n1. اوپری بار میں گھنٹی کے آئیکن پر کلک کریں۔\n2. پینل میں نہ پڑھی گئی اطلاعات عنوان، پیغام اور وقت کے ساتھ دکھائی دیتی ہیں۔\n3. کسی اطلاع پر کلک کریں تاکہ اسے پڑھا ہوا نشان زد کیا جائے۔\n4. «سب کو پڑھا ہوا نشان زد کریں» استعمال کریں تاکہ تمام نہ پڑھی گئی اطلاعات ایک ساتھ صاف ہو جائیں۔\n\nاہم نوٹ:\n• گھنٹی پر ظاہر ہونے والا نمبر نہ پڑھی گئی اطلاعات کی تعداد بتاتا ہے۔',
  },
  'pickup-order-statuses': {
    title: 'وصولی آرڈر کی صورتحال',
    summary: "آپریشنز کے دوران ہر آرڈر کی حیثیت کا مطلب۔",
    content:
      'آپ «وصولی کے آرڈرز» کی فہرست سے موجودہ صورتحال دیکھ سکتے ہیں۔ آرڈر کی پیش رفت کے ساتھ صورتحال خود بخود اپ ڈیٹ ہوتی ہے۔\n\n• زیر التواء — آرڈر بنایا گیا ہے اور پروسیسنگ یا تفویض کا انتظار ہے۔\n• نقل و حمل میں — کچرے کی وصولی یا منتقلی جاری ہے۔\n• مکمل — آرڈر کامیابی سے مکمل ہو گیا۔\n• منسوخ — آرڈر منسوخ کر دیا گیا اور مکمل نہیں ہوگا۔',
  },
  'filter-pickup-orders-by-date': {
    title: 'تاریخ کے مطابق آرڈرز فلٹر کریں',
    summary: "مخصوص تاریخ کی حد میں آرڈر تلاش کریں۔",
    content:
      '1. سائیڈ بار سے «وصولی کے آرڈرز» کھولیں۔\n\n2. «تاریخ کے مطابق فلٹر» والے حصے پر جائیں۔\n\n3. شروع اور اختتام کی تاریخیں مقرر کریں۔\n\n4. فہرست فلٹر کرنے کے لیے «تاریخیں لاگو کریں» پر کلک کریں۔\n\n5. فلٹر ہٹانے اور ڈیفالٹ منظر پر واپس آنے کے لیے «تاریخیں صاف کریں» پر کلک کریں۔',
  },
  'container-fill-level': {
    title: 'کنٹینر کی بھرائی کی سطح',
    summary: "کنٹینر کے لیے درست بھرائی کی سطح منتخب کرنے کا طریقہ۔",
    content:
      '«وصولی آرڈر بنائیں» فارم میں کنٹینر منتخب کرنے پر بھرائی کی سطح بتانا لازمی ہو جاتا ہے۔\n\nدستیاب اختیارات:\n• مکمل بھرا ہوا — کنٹینر مکمل طور پر بھرا ہوا ہے\n• تین چوتھائی بھرا ہوا — تقریباً 75% بھرا ہوا\n• آدھا بھرا ہوا — تقریباً 50% بھرا ہوا\n• ایک چوتھائی بھرا ہوا — تقریباً 25% بھرا ہوا\n\nحقیقی صورتحال کے قریب ترین سطح منتخب کریں تاکہ آپریشنز اور ڈرائیورز بہتر منصوبہ بندی کر سکیں۔',
  },
  'container-statuses': {
    title: 'کنٹینر کی صورتحال',
    summary: "ہر کنٹینر حیثیت کا مطلب اور کب استعمال کریں۔",
    content:
      '«کنٹینرز کی فہرست» سے کنٹینر شامل یا ترمیم کرتے وقت صورتحال مقرر یا دیکھی جا سکتی ہے۔\n\n• وصولی کے لیے تیار — کنٹینر تیار ہے اور کچرا جمع کیا جا سکتا ہے۔\n• وصولی کا انتظار — وصولی شیڈول ہے یا عمل کا انتظار ہے۔\n• خالی — جمع کرنے کے لیے کوئی کچرا نہیں۔\n• مرمت میں — کنٹینر عارضی طور پر سروس سے باہر ہے۔\n• تیاری میں — کنٹینر تیار کیا جا رہا ہے۔\n• غیر فعال — کنٹینر فی الحال استعمال میں نہیں۔',
  },
  'print-container-qr': {
    title: 'کنٹینر کا QR کوڈ پرنٹ کریں',
    summary: "فیلڈ استعمال کے لیے QR لیبل بنائیں اور پرنٹ کریں۔",
    content:
      '1. «کنٹینرز» ← «کنٹینرز کی فہرست» کھولیں۔\n\n2. جدول میں کنٹینر تلاش کریں۔\n\n3. اس کی قطار میں QR آئیکن پر کلک کریں۔\n\n4. پرنٹ ڈائیلاگ سے لیبل پرنٹ کریں۔\n\nلیبل کو مقام پر کنٹینر پر چسپاں کریں تاکہ شناخت اور میدانی اسکیننگ آسان ہو۔',
  },
  'edit-material-type': {
    title: 'مواد کی قسم میں ترمیم یا حذف',
    summary: "ری سائیکلنگ سیٹنگز سے مواد کی قسم اپ ڈیٹ یا ہٹائیں۔",
    content:
      '1. «دوبارہ تدویر» ← «مواد کی اقسام» کھولیں۔\n\n2. ترمیم کے لیے: ترمیم کے آئیکن پر کلک کریں، تفصیلات بدلیں، پھر «محفوظ کریں» پر کلک کریں۔\n\n3. حذف کے لیے: حذف کے آئیکن پر کلک کریں، پھر عمل کی تصدیق کریں۔\n\nتنبیہ: فعال وصولی آرڈرز سے منسلک مواد کی قسم نہ حذف کریں۔ پہلے ان آرڈرز کو مکمل یا اپ ڈیٹ کریں۔',
  },
  'edit-or-delete-container': {
    title: 'کنٹینر میں ترمیم یا حذف',
    summary: "فہرست سے کنٹینر اپ ڈیٹ یا ہٹائیں۔",
    content:
      '1. «کنٹینرز» ← «کنٹینرز کی فہرست» کھولیں۔\n\n2. ترمیم کے لیے: ترمیم کے آئیکن پر کلک کریں، تفصیلات بدلیں، پھر «محفوظ کریں» پر کلک کریں۔\n\n3. حذف کے لیے: حذف کے آئیکن پر کلک کریں، پھر عمل کی تصدیق کریں۔\n\nتنبیہ: کنٹینر وصولی آرڈرز سے منسلک ہو سکتا ہے۔ حذف کرنے سے پہلے اس کی تصدیق کریں۔',
  },
  'edit-or-delete-collection-site': {
    title: 'جمع کرنے کی سائٹ میں ترمیم یا حذف',
    summary: "جمع کرنے کا مقام اپ ڈیٹ یا ہٹائیں۔",
    content:
      '1. «کنٹینرز» ← «جمع کرنے کی سائٹیں» کھولیں۔\n\n2. سائٹ کارڈ پر «ترمیم» یا «حذف» پر کلک کریں۔\n\n3. اگر کہا جائے تو حذف کی تصدیق کریں۔\n\nتنبیہ: سائٹ کنٹینرز اور وصولی آرڈرز سے منسلک ہو سکتی ہے۔ حذف کرنے سے پہلے منسلکات کا جائزہ لیں۔',
  },
  'truck-statuses': {
    title: 'گاڑی کی صورتحال',
    summary: "ہر فلیٹ گاڑی کی حیثیت کا مطلب اور کب استعمال کریں۔",
    content:
      'ہر گاڑی کی صورتحال «بیڑے کا انتظام» کی جدول میں دکھائی دیتی ہے۔ شامل یا ترمیم کرتے وقت اسے اپ ڈیٹ کیا جا سکتا ہے۔\n\n• دستیاب — گاڑی ڈرائیور یا سفر کے لیے تفویض کے لیے تیار ہے۔\n• غیر دستیاب — گاڑی فی الحال استعمال نہیں ہو سکتی۔\n• نقل و حمل میں — گاڑی سڑک پر ہے۔\n• لوڈنگ / ان لوڈنگ — گاڑی لوڈنگ یا ان لوڈنگ کے مقام پر ہے۔\n• مرمت میں — گاڑی مرمت یا سروس میں ہے۔\n\nمشورہ: عارضی بندش پر «غیر دستیاب» یا «مرمت میں» رکھیں، حذف نہ کریں۔',
  },
  'view-driver-details': {
    title: 'ڈرائیور کی تفصیلات دیکھیں',
    summary: "ڈرائیور پروفائل، لائسنس معلومات اور تفویض شدہ ٹرک کھولیں۔",
    content:
      '1. سائیڈ بار سے «ڈرائیورز» کھولیں۔\n\n2. جدول میں ڈرائیور تلاش کریں۔\n\n3. تفصیلات کھولنے کے لیے دیکھنے (آنکھ) کے آئیکن پر کلک کریں۔\n\n4. ڈائیلاگ میں دکھایا جاتا ہے: اکاؤنٹ کی معلومات، ذاتی تفصیلات، لائسنس کی معلومات، اور تفویض شدہ ٹرک اگر ہو۔\n\n5. ترمیم کے لیے: ڈائیلاگ میں «ترمیم» پر کلک کریں، یا قطار کے عمل مینو کا استعمال کریں۔\n\nاگر ٹرک «تفویض نہیں» دکھائے تو عمل مینو سے «ٹرک پر تفویض کریں» منتخب کریں۔',
  },
  'edit-or-delete-vehicle': {
    title: 'گاڑی میں ترمیم یا حذف',
    summary: "گاڑی کی تفصیلات اپ ڈیٹ کریں یا فلیٹ سے ٹرک ہٹائیں۔",
    content:
      'گاڑی میں ترمیم:\n1. «ٹرکس» ← «بیڑے کا انتظام» کھولیں۔\n2. قطار میں ترمیم کے آئیکن پر کلک کریں، یا تفصیلات کھول کر «ترمیم» منتخب کریں۔\n3. خانے بدلیں اور «محفوظ کریں» پر کلک کریں۔\n\nگاڑی حذف کریں:\n1. قطار میں حذف کے آئیکن پر کلک کریں، یا تفصیلات سے حذف کریں۔\n2. حذف کی تصدیق کریں۔\n\nتنبیہ: اگر گاڑی ڈرائیور کو تفویض ہے یا فعال سفر سے منسلک ہے تو حذف کرنے سے آپریشنز متاثر ہو سکتے ہیں۔',
  },
  'edit-or-delete-driver': {
    title: 'ڈرائیور میں ترمیم اور ٹرک تفویض',
    summary: "ڈرائیور معلومات اپ ڈیٹ کریں اور ٹرک تفویض منظم کریں۔",
    content:
      'ڈرائیور کی تفصیلات میں ترمیم:\n1. «ڈرائیورز» کھولیں۔\n2. قطار کے عمل مینو سے «ڈرائیور میں ترمیم» منتخب کریں۔\n3. تفصیلات بدلیں اور «محفوظ کریں» پر کلک کریں۔\n\nمتبادل: دیکھنے کے آئیکن پر کلک کریں پھر تفصیلات سے «ترمیم» منتخب کریں۔\n\nٹرک تفویض کریں:\n1. عمل مینو سے «ٹرک پر تفویض کریں» منتخب کریں۔\n2. دستیاب ٹرک (جس پر ڈرائیور تفویض نہیں) منتخب کریں اور تصدیق کریں۔\n\nتفویض منسوخ کریں:\n1. عمل مینو سے «ٹرک سے تفویض منسوخ کریں» منتخب کریں (صرف تفویض ہونے پر ظاہر ہوتا ہے)۔\n2. عمل کی تصدیق کریں۔',
  },
};
